<template>
    <div class="time_table">
        <div class="time_table_head">
            <div class="time_table_head_switcher flex flex-wrap justify-between">
                <div class="schedule_button flex">
                    <button class="p-2 bg-gray-50 border border-gray-300"
                            @click="weak>0 ? weak=weak-1 : ''"
                            :class="weak===0 ? 'opacity-30' : ''">
                        <span class="material-icons">chevron_left</span>
                    </button>
                    <button class="p-2 bg-gray-50 border border-gray-300"
                            @click="weak=weak+1"
                    >
                        <span class="material-icons">navigate_next</span>
                    </button>
                </div>
                <div class="self-center text-green-600">
                    <span>{{ d.toLocaleDateString('en-us', {month: 'short'}) }} - {{ d.getFullYear() }} </span>
                </div>
                <div>
                    <select 
                        @change="changeUserTimeZone"
                        class="user-timezone-select rounded-full w-full min-w-3/4 bg-white focus:bg-indigo-100 mt-2 p-2 border border-gray-300 shadow-md px-9">
                        <option v-for="(item,key) in timezoneLists" :key="key" :value="item.timezone">{{ item.offset }} - {{ item.timezone }}</option>
                    </select>
                </div>
            </div>
            <div class="days_head m-4 ">
                <div class="grid grid-cols-7 md:grid gap-0">
                    <div v-for="day in days"
                         class="days_name col-span-1 p-3 text-center"
                         :class="checkIsToday(day) ? 'today-header-date' :''"
                    >
                        <p class="text-lg">{{ day.name }}</p>
                        <p class="text-gray-500">{{ day.day }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="calender grid md:grid grid-cols-7 gap-0 m-4">
            <div v-for="day in days" class="day-swich col-span-1 py-3">
                <div
                    v-for="(timeName,key) in times[day.name].name"
                     :key="key"
                     v-show="timeName && checkValidDay(day, timeName)"
                     @click="!times[day.name].isReserved[key] && checkValidDay(day, timeName) ? selected_date=times[day.name].date[key] : ''"
                     :date-id="times[day.name].date[key]"
                     class=" font-bold text-center py-3 cursor-pointer hover:border border-indigo-400 w-3/4 mx-auto rounded-xl my-1"
                     :class="checkIsToday(day) ? 'today-date' : times[day.name].isReserved[key] ?
                     'text-red-400 hover:border-none text-white opacity-30 cursor-pointer' : 'text-green-600',
                     selected_date===times[day.name].date[key] && canSelectable? 'selected-date' : ''
                     "
                     :style="times[day.name].isReserved[key] ? 'opacity:0.3; cursor:unset' : ''"
                >{{ timeName }}
                </div>
            </div>
        </div>
        <div class="justify-around">
            <div class="flex w-1/2">
                <div class="w-4 h-4 bg-green-300"></div>
                <span class="ml-1 font-bold text-gray-600 text-base">Available</span>
            </div>
            <div class="flex w-1/2">
                <div class="w-4 h-4 bg-red-300"></div>
                <span class="ml-1 font-bold text-gray-600 text-base">Booked</span>
            </div>
        </div>
    </div>
</template>

<script>
import {getTimezoneList, getTimezoneByCountry, getTimezoneGroupByCountryCode} from "country-timezone-list";
import Select from "@/Jetstream/Select";
import moment from '@/moment';

const country = getTimezoneList();
var CURRENT_DATE = new Date();
let d = new Date();
let d2 = new Date();
var tz = moment.tz.guess();
moment.tz.setDefault(tz);

var content = 'January February March April May June July August September October November December'.split(' ');
var weekDayName = 'SUN MON TUES WED THURS FRI'.split(' ');
var daysOfMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export default {
    name: "FrontSchedule",
    components: {Select},
    props: {
        canSelectable: {
            type: Boolean,
            default: true
        },
        date: Object,
        holiday: Array,
        start_date: String,
        end_date: String,
        minute_shift: String,
        day_valid: String,
        busy_time: Array,
        time_zone: {
            type: String,
            default: 'America/Toronto'
        },
        timezoneLists: Array,
    },
    data() {
        return {
            selected_date: null,
            country: country,
            rang_date: null,
            weak: 0,
            days: [],
            times: [],
            status: 'next',
            d: new Date(),
            d2: new Date(),
        }
    },
    watch: {
        selected_date(val) {
            this.$emit('input', val, tz);
        },
        weak(newval, oldval) {
            this.status = newval > oldval ? 'next' : 'prev'
            this.setDate(oldval, newval)
            this.setTime()
        },
    },
    mounted() {
        this.setDate()
        this.setTime()
        const vm = this;
        setTimeout(function () {
            vm.setUserTimeZone();
        }, 100);
    },
    methods: {
        checkValidDay(_day, _time) {
            let date = `${_day.date} ${_time}`;
            date = new moment(date);
            let now = moment.utc(new Date() ).tz(tz).format('YYYY-MM-DD HH:mm'),
                diff = date.diff(now, 'days');
            return diff != 0 && diff != 1 ? true : false;
        },
        changeUserTimeZone(_val) {
            tz = _val?.target?.value;
            // tz = getTimezoneList().find(item => item.name === select.value).name
            this.d = new Date();
            this.d2 = new Date();
            this.setTime()
            this.setDate()
        },
        setUserTimeZone() {
            const vm = this;
            this.timezoneLists.forEach(function (index, key) {
                if (index.timezone === tz) {
                    let select = document.getElementsByClassName('user-timezone-select');
                    select.forEach( function(index) {
                        index[key].selected = true;
                    });
                }
            });
        },
        setTime(date) {
            var array_days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            // var array_days=new Array()
            this.days.forEach(item => {
                array_days.push(item.name)
            })
            // var days=date.toLocaleDateString('en-us', { weekday: 'short' })
            let j = 0
            const app = this
            this.date.forEach((val, key) => {
                var times = [];
                var dates = [];
                var isReserved = []
                var tt = 0; // start time
                const startTime = this.start_date.split(':')
                tt = (startTime[0] * 60) + parseInt(startTime[1])

                let i = 0;

                let date = this.getDay(key, this.d2)

                const dayLabel = moment(date).format("ddd");

                let scheduleValues = this.date[this.getDayScheduleKey(dayLabel)];

                const timezone = this.timezoneLists.find(item => item.timezone === app.time_zone).offset.split(':')
                let isIgnoreDay = false;
                // if (app.day_valid && parseInt(app.day_valid) > 0) {
                //     const ignoreDays = parseInt(app.day_valid) - 1;

                //     const momentDate = moment(date);
                //     const momentDayValidDate = moment().add(ignoreDays, 'days');

                //     if (momentDate.diff(momentDayValidDate) < 0) {
                //         isIgnoreDay = true;
                //     }
                // }

                if (scheduleValues && scheduleValues.length && !isIgnoreDay) {
                    scheduleValues = scheduleValues.sort((a, b) => a - b)

                    scheduleValues.forEach((scheduleValue) => {
                        const scheduleTime = tt + (this.minute_shift * scheduleValue)

                        var hh = Math.floor((scheduleTime / 60)) - (parseInt(timezone[0]))
                        // hh = hh +1;
                        hh < 0 ? hh = 24 + hh : ''
                        // console.log(hh)

                        var mm = ((scheduleTime - (parseInt(timezone[1]))) % 60)
                        let d = new Date(date).setUTCHours(("0" + (hh)).slice(-2), ("0" + (mm)).slice(-2));
                        //   dates[i]= moment.utc(d-(48*60*60*1000))

                        times[i] = moment.utc(d).tz(tz).format('HH:mm');

                        let t = times[i].split(":");
                        //console.log(date,times[i])
                        dates[i] = moment(date).set({
                            h: t[0],
                            m: t[1],
                        });

                        //tt = tt + this.minute_shift;
                        for (let course of this.busy_time) {
                            if (dates[i].format('YYYY-MM-DD') === course.chosen_date) {
                                // console.log(moment.utc(new Date(d), this.time_zone).format('HH:MM'),new Date(d).toLocaleString('en-us', { timeZone: 'America/Adak'}))
                                if (parseInt(this.timeToMinute(moment.utc(d).format('HH:mm'))) === parseInt(this.timeToMinute(course.chosen_time))) {
                                    isReserved[i] = true
                                }
                            }
                        }

                        this.holiday.forEach((value, key) => {
                            if (new Date(value.date).toDateString() === date.toDateString()) {
                                let t = moment.utc(d).format('HH:mm')
                                if (parseInt(this.timeToMinute(t)) > parseInt(this.timeToMinute(value.time1)) &&
                                    parseInt(this.timeToMinute(t)) < parseInt(this.timeToMinute(value.time2))) {
                                    dates.splice(i, 1)
                                    times.splice(i, 1)
                                }
                            }
                        })

                        i++
                    })
                }

                this.times[dayLabel] = {name: times, date: dates, isReserved: isReserved}

                j++
            })
        },
        getDayScheduleKey(day) {
            const keysByDay = {
                Sun: 0,
                Mon: 1,
                Tue: 2,
                Wed: 3,
                Thu: 4,
                Fri: 5,
                Sat: 6,
            }

            return keysByDay[day];
        },
        timeToMinute(val) {
            let time = val.split(':')
            let minute = time[0] * 60 + time[1]
            return minute
        },
        addDays(days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        },
        setDate(oldval, newval) {
            this.days = new Array()
            var baseDate = new Date(Date.UTC(2017, 0, 2)); // just a Monday
            let i = 0
            for (i; i < 7; i++) {
                const result = this.getDay(i, this.d)
                let dayName = result.toLocaleDateString('en-us', {weekday: 'short'});
                let isToday = i === 0 ? true : false
                let day = moment.utc(result).tz(tz).format(' D')
                let date = moment.utc(result).tz(tz).format('YYYY-MM-DD')
                this.days.push({'name': dayName.slice(0, 4), 'day': day, 'isToday': isToday, 'date': date})
                baseDate.setDate(baseDate.getDate() + 1);
                // this.setTime(result)
            }
        },

        getDay(day, d) {
            let isDay;
            if (day === 0 && this.weak === 0 && this.status === 'next') {
                isDay = new Date(d.setDate(d.getDate()))
            } else if (this.status === 'next') {
                isDay = new Date(d.setDate(d.getDate() + 1))
            } else {
                isDay = day === 0 ? new Date(d.setDate(d.getDate() - 13)) :
                    new Date(d.setDate(d.getDate() + 1))
            }
            return isDay
        },
        getTimeZone() {
            var offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
            var timeZoneOffset = (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
            return timeZoneOffset
        },
        changeTimezone(date, ianatz) {

            // suppose the date is 12:00 UTC
            var invdate = new Date(date.toLocaleString('en-US', {
                timeZone: ianatz
            }));

            // then invdate will be 07:00 in Toronto
            // and the diff is 5 hours
            var diff = date.getTime() - invdate.getTime();

            // so 12:00 in Toronto is 17:00 UTC
            return new Date(date.getTime() - diff); // needs to substract

        },
        checkIsToday(_day){
            let now = moment.utc(new Date() ).tz(tz).format('YYYY-MM-DD');
            return _day.date == now ? true : false;
        }
    }
}
</script>

<style scoped>
.selected-date {
    background-color: #b6e0d3;
    border: 1px solid #b6e0d3;
    color: #37584d;
    width: 40px
}

.today-date {
    background-color: #eef2ff;
    border: 1px solid #eef2ff;
    color: #2a3042;
    width: 40px
}

.today-header-date {
    background-color: #eef2ff;
    border: 1px solid #eef2ff;
    color: #4d546b;
    width: 60px
}

@media only screen and (max-width: 600px) {
    .today-header-date {
        background-color: #eef2ff;
        border: 1px solid #eef2ff;
        color: #4d546b;
        width: 47px
    }
}
</style>
